import Alpine from 'alpinejs';
import anchor from '@alpinejs/anchor';

Alpine.plugin(anchor);

import './scripts/utils';
import './sections/bundle-upsell';
import './sections/upsell-products';
import './sections/header';
import './sections/login-cards';
import './sections/select-subjects';
import './sections/past-papers-builder';
import './snippets/loadingButton';
import './snippets/schoolCollectionLink';
import './scripts/localisation';

// Templates
import './templates/collection/school-parent-portal-setup';

Alpine.start();

declare global {
  interface Window {
    routes: {
      cart_add_url: string;
    };
    theme: {
      parentPaymentSystem: string;
    };
  }
}
